import { render, staticRenderFns } from "./OrdemAberta.vue?vue&type=template&id=6914984a&"
import script from "./OrdemAberta.vue?vue&type=script&lang=js&"
export * from "./OrdemAberta.vue?vue&type=script&lang=js&"
import style0 from "./OrdemAberta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports